import { ALL_WORD } from 'global/constants';
import { DropdownListItem } from 'webclient.constants';
import { Alias } from 'approot/shared/graphql/startup-data/startup-data.hooks';

export const getNewFilterSelection = <Option extends string>(
  currentSelection: Option[] | undefined | null,
  selectedOption: Option | undefined,
  allOption: string = ALL_WORD
): Option[] => {
  const oldSelection = currentSelection || [];
  if (!selectedOption) return oldSelection;
  if (selectedOption === allOption) {
    // Deselect everything
    return [];
  }
  let newSelection: Option[] = [];
  const alreadyExists = oldSelection.includes(selectedOption);
  if (alreadyExists) {
    // Deselect option
    newSelection = oldSelection.filter(item => item !== selectedOption);
  } else {
    // Add newly selected option
    newSelection = [...oldSelection, selectedOption];
  }
  return newSelection;
};

export function getNewFilterSelectionObjects<
  Option extends { value: string; label: string },
>({
  currentSelection,
  selectedOption,
  allOption = {
    value: ALL_WORD,
    label: ALL_WORD,
  } as unknown as Option,
}: {
  currentSelection: Option[] | undefined | null;
  selectedOption: Option | undefined;
  allOption?: Option;
}): Option[] {
  const oldSelection = currentSelection || [];
  if (!selectedOption) return oldSelection;
  if (selectedOption.value === allOption.value) {
    // Deselect everything
    return [];
  }
  let newSelection: Option[] = [];
  const alreadyExists = oldSelection.some(
    item => item.value === selectedOption.value
  );
  if (alreadyExists) {
    // Deselect option
    newSelection = oldSelection.filter(
      item => item.value !== selectedOption.value
    );
  } else {
    // Add newly selected option
    newSelection = [...oldSelection, selectedOption];
  }
  return newSelection;
}

export const sanitiseFilterValues = <FilterValue extends string>(
  paramValues: unknown[],
  filterData: DropdownListItem<FilterValue>[],
  aliases?: Alias[]
) => {
  return filterData.reduce((filterValues, item) => {
    if (paramValues.includes(item.value)) {
      filterValues.push(item.value);
    } else if (aliases) {
      const alias = aliases.find(a => a.paramName === item.value);
      if (alias && paramValues.includes(alias.alias)) {
        filterValues.push(item.value);
      }
    }
    return filterValues;
  }, [] as FilterValue[]);
};
